export const notEmptyMessage = 'Cannot be empty';
export const mustBeNumberMessage = 'Must be number';
export const minValueErrorMessage = 'Min value should be less than max value';
export const maxValueErrorMessage = 'Max value should be more than min value';
export const minOrMaxSet = 'Min or Max should be set';
